import { FieldSet, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

// TODO - REIMPLEMENT FOLLOWING DogRequest ENTITY REMOVAL import { DogLinkedRequestApi, DogLinkedRequestSearch } from "../../../../../api";
import { useGlobalData } from "../../../../../contexts";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { CustomDataTable, ExportButton } from "../../../../../components";
import { DogBaseSearch, DogLinkedRequestApi, RequestGridDto } from "../../../../../api";
import { Link } from "react-router-dom";
import { ERoutes } from "../../../../../ERoutes";
import { getRouteStr } from "../../../../../utils/RequestRouteUtil";
import { getSearchRouteStr } from "../../../../../utils/RequestSearchRouteUtil";

export interface IDogLinkedFilesPageProps {
  dogId: number;
}

export const DogLinkedFilesPage: React.FunctionComponent<IDogLinkedFilesPageProps> = ({ dogId }) => {
  const { t } = useTl();
  const api = useApiService(DogLinkedRequestApi);
  const [sobjState, setsobjState] = React.useState<any>();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.RequestType),
        fieldName: "requestType",
        render: (row: RequestGridDto) => (
          <Link target="_blank" to={getSearchRouteStr(row.requestTypeCode)}>
            {row.requestType}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.RequestNumber),
        fieldName: "requestNumber",
        render: (row: RequestGridDto) => {
          return (
            <Link target="_blank" to={getRouteStr(row.requestTypeCode, row.subRequestId, "edit")}>
              {row.requestNumber}
            </Link>
          );
        },
      },
      {
        header: () => t(ETLCodes.ParentRequest),
        fieldName: "parentRequest",
        render: (row: RequestGridDto) => {
          if (row.parentRequestId) {
            return (
              <Link target="_blank" to={`${ERoutes.requests}/${row.parentRequestId}/detail/view`}>
                {row.parentRequest}
              </Link>
            );
          } else {
            return "/";
          }
        },
      },
      {
        header: () => t(ETLCodes.RequestDate),
        fieldName: "requestDate",
      },
      {
        header: () => t(ETLCodes.RequestState),
        fieldName: "requestState",
      },
      {
        header: () => t(ETLCodes.Contact),
        fieldName: "contact",
        render: (row: RequestGridDto) => (
          <Link target="_blank" to={`${ERoutes.people}/${row.personId}/detail/view`}>
            {row.contact}
          </Link>
        ),
      },
    ],
    [t]
  );

  const tableState = useGridState({
    serverMode: true,
    enablePagination: true,
    enableFilter: false,
    availablePageSizes: [15, 25, 50],
    pageSize: 15,
    sortKeys: { requestNumber: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj: DogBaseSearch) => {
      const s = DogBaseSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, dogId: dogId });
      setsobjState(s);
      return api.baseSearch(s);
    },
    [api, currentLanguage.languageId, dogId]
  ); // TO REIMPLEMENT (sObj: DogLinkedRequestSearch) => api.baseSearch(DogLinkedRequestSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, dogId: dogId })),[]);

  const { loading } = useSearchApi({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  return (
    <FieldSet
      title={t(ETLCodes.LinkedRequests)}
      rightElement={<ExportButton sObj={sobjState} exportFunction={(sObj) => api.exportXlsFile(sObj)} />}
    >
      <CustomDataTable tableState={tableState} loading={loading} columns={columns} />
    </FieldSet>
  );
};
